import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../../../../../Context/HomeContext";
import tick from "../../../../../../../assets/Tick.png";

export default function Material() {
  const { material, setMaterial , dataClient } = useContext(HomeContext);

  return (
    <>
      <div className="Rose-material">
        <div className="Rose-material-title">
          <span>Choose Material</span>
        </div>
        <div className="Rose-material-list">
          {dataClient?.design?.packaging?.material.map((m) => {
            return (
              <div
                className="Rose-material-list-item"
                key={m.id}
                style={{
                  border:
                    material?.title === m.title
                      ? "1px solid #000000"
                      : "0.5px solid #BFBFBF",
                  backgroundColor:
                    material?.title === m.title ? "#F8E8E9" : "#ffffff",
                }}
                onClick={() => {
                  setMaterial(m);
                }}
              >
                <div className="Tick">
                  <img
                    src={tick}
                    alt="tick"
                    style={{
                      display: material?.title === m.title ? "inline" : "none",
                    }}
                  />
                </div>
                <span
                  style={{
                    fontWeight: material?.title === m.title ? "700" : "400",
                    color: material?.title === m.title ? "#000000" : "#5C5E62",
                  }}
                >
                  {m.title}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
